export interface Video {
  id: string;
  title: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  duration: string;
  views: string;
  rating: string;
  year: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-apps-2-line' },
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-music-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '直播', slug: 'live', icon: 'ri-live-line' },
  { name: '体育', slug: 'sports', icon: 'ri-basketball-line' },
];

export const videos: Video[] = [
  {
    id: 'v1',
    title: '流浪地球3',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20earth%20engines%2C%20cinematic%20lighting%2C%20dramatic%20orange%20and%20warm%20tones%2C%20epic%20scale%2C%20clean%20gradient%20background&width=640&height=360&seq=baoyu-v1&orientation=landscape',
    category: '电影',
    categorySlug: 'movie',
    duration: '148分钟',
    views: '2.3亿',
    rating: '9.2',
    year: '2026',
    description: '太阳即将膨胀吞噬地球，人类面临前所未有的生存危机，全球联合政府启动"流浪地球计划"，在地球表面建造上万座行星发动机，推动地球离开太阳系，踏上长达2500年的星际流浪之旅。',
    tags: ['科幻', '冒险', '灾难', '国产大片'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v2',
    title: '繁花似锦',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%20elegant%20traditional%20costumes%2C%20warm%20golden%20lighting%2C%20artistic%20composition%2C%20classical%20Chinese%20aesthetic%2C%20soft%20gradient%20background&width=640&height=360&seq=baoyu-v2&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv',
    duration: '45集',
    views: '1.8亿',
    rating: '8.9',
    year: '2025',
    description: '以上世纪九十年代的上海为背景，讲述了阿宝、玲子、李李等人在改革开放浪潮中的商海沉浮与情感纠葛，展现了那个充满机遇与挑战的时代画卷。',
    tags: ['都市', '情感', '商战', '年代剧'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v3',
    title: '欢乐喜剧人·第九季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20poster%20with%20bright%20colorful%20stage%20lights%2C%20comedians%20on%20stage%2C%20festive%20atmosphere%2C%20warm%20lighting%2C%20entertaining%20vibe%2C%20clean%20colorful%20background&width=640&height=360&seq=baoyu-v3&orientation=landscape',
    category: '综艺',
    categorySlug: 'variety',
    duration: '12期',
    views: '3.5亿',
    rating: '8.7',
    year: '2026',
    description: '国内顶尖喜剧人齐聚一堂，通过相声、小品、脱口秀等多种形式为观众带来欢笑盛宴，新老喜剧人的精彩对决让你笑到停不下来。',
    tags: ['喜剧', '综艺', '搞笑', '竞技'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v4',
    title: '深海秘境',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20underwater%20fantasy%20world%2C%20colorful%20coral%20reefs%2C%20mystical%20creatures%2C%20dreamy%20atmosphere%2C%20vibrant%20warm%20colors%2C%20soft%20gradient%20background&width=640&height=360&seq=baoyu-v4&orientation=landscape',
    category: '动漫',
    categorySlug: 'anime',
    duration: '110分钟',
    views: '1.2亿',
    rating: '9.0',
    year: '2025',
    description: '少女小海在一次意外中坠入深海，发现了一个隐藏千年的海底文明世界，她必须与海洋生物联手，对抗即将苏醒的远古巨兽，拯救两个世界。',
    tags: ['奇幻', '冒险', '国产动画', '治愈'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v5',
    title: '大美中国·山河篇',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20nature%20documentary%20poster%20with%20majestic%20mountains%2C%20flowing%20rivers%2C%20aerial%20landscape%20photography%2C%20golden%20sunlight%2C%20natural%20warm%20tones%2C%20clean%20sky%20background&width=640&height=360&seq=baoyu-v5&orientation=landscape',
    category: '纪录片',
    categorySlug: 'documentary',
    duration: '10集',
    views: '8900万',
    rating: '9.5',
    year: '2026',
    description: '历时五年拍摄，横跨中国三十四个省级行政区，用4K超高清镜头记录祖国壮丽山河与珍稀野生动植物，展现人与自然和谐共生的美丽画卷。',
    tags: ['自然', '地理', '4K', '人文'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v6',
    title: '电竞巅峰·LPL春季赛',
    coverImage: 'https://readdy.ai/api/search-image?query=E-sports%20arena%20with%20large%20LED%20screens%2C%20gaming%20stage%2C%20dramatic%20stage%20lighting%2C%20competitive%20atmosphere%2C%20warm%20and%20cool%20toned%20lights%2C%20clean%20dark%20background&width=640&height=360&seq=baoyu-v6&orientation=landscape',
    category: '体育',
    categorySlug: 'sports',
    duration: '直播',
    views: '4.2亿',
    rating: '9.1',
    year: '2026',
    description: '2026年英雄联盟职业联赛春季赛全程直播，十六支顶尖战队角逐冠军荣耀，精彩团战、极限操作，每一场都是视觉盛宴。',
    tags: ['电竞', 'LOL', '直播', '竞技'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v7',
    title: '长安十二时辰·续',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20ancient%20Tang%20dynasty%20cityscape%2C%20lantern-lit%20streets%2C%20traditional%20architecture%2C%20warm%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20dark%20gradient%20background&width=640&height=360&seq=baoyu-v7&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv',
    duration: '48集',
    views: '2.6亿',
    rating: '9.3',
    year: '2026',
    description: '故事发生在上一季的三年后，长安城再次面临惊天危机，张小敬与李必再度联手，揭开隐藏在繁华都市背后的惊天阴谋。',
    tags: ['古装', '悬疑', '历史', '动作'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v8',
    title: '美食侦探·寻味中国',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20steaming%20hot%20traditional%20dishes%2C%20street%20food%20market%20scene%2C%20warm%20kitchen%20lighting%2C%20appetizing%20food%20photography%2C%20clean%20warm%20toned%20background&width=640&height=360&seq=baoyu-v8&orientation=landscape',
    category: '综艺',
    categorySlug: 'variety',
    duration: '24期',
    views: '1.5亿',
    rating: '9.0',
    year: '2025',
    description: '跟随美食侦探走访中国各地，探寻最地道的地方特色美食，从街头小吃到宫廷盛宴，每一口都是文化的传承与味蕾的狂欢。',
    tags: ['美食', '旅行', '文化', '真人秀'],
    isHot: false,
    isNew: false,
  },
];